import { Button, Col, Image, Row } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import ByMuvu from '../../PatientLandingGeneralComponents/ByMuvu';
import GreenCheckCircle from "../../images/GreenCheckCircle.svg";

const Success = ({ countryCode, examName, hasMoreSurveys }) => {
  const navigate = useNavigate();

  return (
    <Row className='patient-landing-container mt-70 mr-50 ml-50' justify='center'>
      <Col span={24} className="mb-40 text-center ">
        <Image
          width={50}
          src={GreenCheckCircle}
        />
      </Col>
      <Col span={24} className="mb-70 text-center pl-70 pr-70">
        <h2 className="title-success">¡Haz finalizado tu examen!</h2>
      </Col>
      <Col span={24} className="mb-60 pl-30 pr-30">
        <p className="text-center">
          {hasMoreSurveys 
            ? "Te invitamos a continuar con tu siguiente examen."
            : "Te invitamos a continuar con tu proceso de exámenes"}
        </p>
      </Col>
      <Col span={24} className="mb-70">
        <p className="text-center"><strong>¡Muchas gracias!</strong></p>
      </Col>
      <Col span={24} xl={12} xxl={12} md={12} className="text-center" style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
        <Button
          className="cmt-button primary"
          type="primary"
          size='large'
          block
          onClick={() => navigate(`/mis-examenes/${countryCode}`)}
        >
          {hasMoreSurveys ? "Siguiente Examen" : "Volver al Inicio"}
        </Button>
      </Col>
      <Col span={24} className='mt-30'>
        <ByMuvu />
      </Col>
    </Row>
  )
}

export default Success;
